<template>
  <div>
    <div class="coursesole">
      <div class="header_screen container_wrap">
        <div class="header_screen_item">
          <div class="header_screen_item_title">类型</div>
          <div class="header_screen_item_el" :class="{ red: c === index }"  @click="getall()">
            全部
          </div>
          <div
            class="header_screen_item_el"
            v-for="(item, index) in cateTreeList"
            :key="index"
            :class="{ red: c === index }"
            @click="getselect(item.value, item.title, index)"
          >
            {{ item.title }}
          </div>
        </div>
        <div class="header_screen_item"></div>
        <div class="header_screen_searchinput">
          <el-input placeholder="搜索您想要的…" v-model="searchinputdata">
            <i
              class="el-icon-search el-input__icon"
              slot="suffix"
              @click="handlesearchinputclick"
            >
            </i>
          </el-input>
        </div>
      </div>
      <div class="course_list container_wrap">
        <div
          class="course_list_item"
          v-for="(item, i) in courseList2"
          :key="i"
          v-rblink="{ name: 'CourseDetail', query: { id: item.id } }"
        >
          <div class="course-pic-box">
            <img width="100%" :src="item.pic_url" alt="" />
            <span v-if="item.level">{{ item.level }}</span>
          </div>
          <div class="course-title on-show-one">{{ item.title }}</div>
          <div class="course-price-box">
            <span class="course-price" v-if="item.price > 0"
              >¥{{ item.price }}</span
            ><span class="course-num" v-if="item.video_count > 0"
              >{{ item.video_count }}视频</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CourseItem from "@/components/mainindex/CourseItem";
export default {
  name: "CourseSole",
  data() {
    return {
      searchinputdata: "",
      courseList: [],
      cateTreeList: [],
      courseList2: [],
      cate_id: "",
      c: 0,
      index:""
    };
  },
  mounted() {
    this.getCourseList(); 
    this.getCateTree();
    this.getall()
  },
  methods: {
    getall(){
      var index;
      this.c=index
      this.courseList2=this.courseList
    },
    getselect(val, val2, index) {
      var i = 0;
      var test = [];
      this.cate_id = val;
      this.c = index;
      console.log("cate_id", this.cate_id);
      for (i = 0; i < this.courseList.length; i++) {
        if (this.courseList[i].cate_ids == this.cate_id) {
          test.push(this.courseList[i]);
        }
      }
      this.courseList2 = test;
      console.log("courseList2", this.courseList2);
    },
    getCateTree() {
      this.$api.get(
        "/api/course/cateTreeList",
        this.params,
        (res) => {
          this.cateTreeList = res.data;
        },
        (res) => {
          Toast(res.msg);
        }
      );
    },
    getCourseList() {
      let that = this;
      this.$api.get(
        "/api/course/courseList",
        this.params,
        (res) => {
          that.loading = false;

          if (res.data.currentpage == 1) {
            that.isLoading = false;
            that.courseList = res.data.list;
            this.courseList2 = res.data.list;
          } else {
            that.courseList = that.courseList.concat(res.data.list);
            this.courseList2 = this.courseList2.concat(res.data.list);
          }

          if (res.data.list.length == 0) {
            that.finished = true;
          }
          that.params.pageNo += 1;
        },
        (res) => {
          Toast(res.msg);
        }
      );
    },
    handlesearchinputclick() {},
    handleNavClick(index, item, targerArr) {
      if (item.class != "") {
        return;
      }
      targerArr.some((ele) => {
        if (ele.class != "") {
          ele.class = "";
        }
      });
      targerArr[index].class = "header_screen_item_el_active";
    },
  },
  components: {
    CourseItem,
  },
};
</script>
<style lang="scss" scoped>
.container_wrap {
  width: 1200px;
  margin: 0 auto;
}
.coursesole {
  min-height: 1172px;
  background: #f8f8f8;
  overflow: hidden;
}
.header_screen {
  width: 1200px;
  height: 132px;
  background: #ffffff;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.05);
  margin-top: 13px;
  margin-bottom: 30px;
  position: relative;
  box-sizing: border-box;
  padding: 30px 0 20px 24px;
  .header_screen_searchinput {
    position: absolute;
    width: 218px;
    height: 36px;
    top: 18px;
    right: 17px;
    .el-icon-search {
      font-size: 26px;
      color: #cccccc;
    }
  }
  .header_screen_item {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 40px;
    cursor: default;
    .header_screen_item_title {
      height: 20px;
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      line-height: 20px;
      margin-right: 41px;
    }
    .header_screen_item_el {
      height: 20px;
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      line-height: 20px;
      margin-right: 47px;
      &:hover {
        cursor: pointer;
        color: #f56057;
      }
    }
    .header_screen_item_el_active {
      color: #f56057;
    }
    .red {
      color: red;
    }
  }
}
.course_list {
  .course_list_item {
    margin-right: 13px;
    margin-bottom: 13px;
    display: inline-block;
    box-sizing: border-box;
    &:nth-child(4n) {
      margin-right: 0;
    }
  }
}
.course_list {
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.course_list_item {
  width: 30%;
  margin-top: 20px;
}
</style>


// WEBPACK FOOTER //
// CourseSole.vue?621bf8f3